import React, { useState, useEffect } from 'react';
import { Loader2, Save } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { getStats, updateStats } from '../../utils/api';
import { useToast } from '../../hooks/use-toast';

const fields = [
  { name: 'readers', label: 'Readers Count' },
  { name: 'reviews', label: 'Reviews Count' },
  { name: 'events', label: 'Events Count' },
  { name: 'rating', label: 'Average Rating (e.g. 4.8)' },
];

export default function AdminStats() {
  const { toast } = useToast();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getStats().then(setForm).catch(() => setForm({ readers: 0, reviews: 0, events: 0, rating: 0 }));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateStats({
        readers: Number(form.readers) || 0,
        reviews: Number(form.reviews) || 0,
        events: Number(form.events) || 0,
        rating: Number(form.rating) || 0,
      });
      toast({ title: 'Saved', description: 'Statistics updated successfully' });
    } catch (err) {
      toast({ title: 'Error', description: 'Save failed', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  if (!form) return <div className="flex items-center justify-center py-20"><Loader2 className="h-8 w-8 text-orange-500 animate-spin" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-900 mb-1">Statistics</h1>
      <p className="text-slate-500 text-sm mb-6">Update the animated counters shown on the homepage</p>

      <form onSubmit={handleSave} className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4 max-w-md">
        {fields.map((f) => (
          <div key={f.name}>
            <label className="block text-sm font-medium text-slate-700 mb-2">{f.label}</label>
            <input
              type="number" step="any"
              value={form[f.name] ?? ''}
              onChange={(e) => setForm((p) => ({ ...p, [f.name]: e.target.value }))}
              data-testid={`stats-${f.name}-input`}
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-400 outline-none"
            />
          </div>
        ))}
        <Button type="submit" disabled={saving} data-testid="save-stats-btn" className="bg-orange-500 hover:bg-orange-600 text-white">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
          Save
        </Button>
      </form>
    </div>
  );
}
